import { AddAttachmentsModal } from 'features/ai-assistant/ui/AddAttachmentsModal'
import { FilesPreviewModal } from 'features/files-preview/ui/FilesPreviewModal'
import { CreateTeamModal } from 'features/team/ui/CreateTeamModal'
import { InviteMembersModal } from 'features/team/ui/InviteMembersModal'
import { JoinTeamModal } from 'features/team/ui/JoinTeamModal'
import { AuthModal } from 'features/user/ui/AuthModal'
import { ForgotPassModal } from 'features/user/ui/ForgotPassModal'
import { SignUpConfirmationSendToModal } from 'features/user/ui/SignUpConfirmationSendToModal'
import { UserAgreementModal } from 'features/user/user-agreement/ui/UserAgreementModal'
import { DuplicateActionModal } from 'features/files-uploading/ui/DuplicateActionModal'
import { PlansModal } from 'features/team/ui/plan/PlansModal'

import { ConfirmationByLinkErrorModal } from '../../user/ui/ConfirmationByLinkErrorModal'
import { ConfirmationByLinkSuccessModal } from '../../user/ui/ConfirmationByLinkSuccessModal'

import {
  CopyMoveItemsModal,
  DeleteItemModal,
  RemoveFromBoardModal,
  RenameItemModal,
  ShareLinkItemsModal
} from './modals'

export const GlobalModals = () => {
  return (
    <>
      <AuthModal />

      <SignUpConfirmationSendToModal />

      <ConfirmationByLinkErrorModal />

      <ConfirmationByLinkSuccessModal />

      <CreateTeamModal />

      <JoinTeamModal />

      <ForgotPassModal />

      <InviteMembersModal />

      <UserAgreementModal />

      <FilesPreviewModal />

      {/* New Modals */}

      <ShareLinkItemsModal />

      <RenameItemModal />

      <DeleteItemModal />

      <RemoveFromBoardModal />

      <CopyMoveItemsModal />

      <AddAttachmentsModal />

      <DuplicateActionModal />

      <PlansModal />
    </>
  )
}

